import type { AdminPageAccessRule } from '../../registry.ts';

/** Хто бачить сторінку `queues`: у перший екран їде лише це (опис і код — у `page.ts`). */
export default {
  group: 'processes',
  permission: 'assignment.manage',
} satisfies AdminPageAccessRule;
